import * as React from "react";
const SvgFiRrBookAtlas = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M17 0H7C4.243 0 2 2.243 2 5v15c0 2.206 1.794 4 4 4h11c2.757 0 5-2.243 5-5V5c0-2.757-2.243-5-5-5M7 2h10c1.654 0 3 1.346 3 3v11H6a4 4 0 0 0-2 .537V5c0-1.654 1.346-3 3-3m10 20H6c-1.103 0-2-.897-2-2s.897-2 2-2h14v1c0 1.654-1.346 3-3 3m-2.392-8.666c.251-1.215.351-2.473.39-3.334h2.935a6 6 0 0 1-2.448 3.882c-.41.291-.978-.055-.877-.548M13 8h-1.954c.107-2.564.416-4.829.977-4.829S12.893 5.436 13 8m1.608-3.334c-.102-.493.466-.839.877-.548A5.99 5.99 0 0 1 17.933 8h-2.935c-.039-.861-.14-2.119-.39-3.334M6.113 10h2.935c.039.861.14 2.119.39 3.334.102.493-.466.839-.877.548A6 6 0 0 1 6.113 10m2.935-2H6.113a6 6 0 0 1 2.448-3.882c.41-.291.978.055.877.548-.251 1.215-.351 2.473-.39 3.334m1.998 2H13c-.107 2.564-.435 4.829-.977 4.829s-.87-2.265-.977-4.829"
    />
  </svg>
);
export default SvgFiRrBookAtlas;
